/**
 * The feature KEYS the gate (`./shared.ts`, `checkFeature`) answers — all of web's, on both
 * platforms. Uplifted from `helper/featureRestrictionHelper`; web declared 55, mobile 49 (a strict
 * subset with identical values), and mobile now has web's gate for My Orders, so the table is one
 * object.
 *
 * ⚠️ A STORE-FREE LEAF on purpose. The gate beside it reads the store, the facade and navigation,
 * so importing `./shared` (or the folder) loads all three. Views, and core modules that node tests
 * load (`myOrders/orderDetail`), import the keys from HERE:
 * `@rista/core/helpers/featureRestrictionHelper/features`.
 *
 * ⚠️ Key ORDER is not load-bearing: nothing iterates this object; every consumer indexes it by
 * name. `as const` IS load-bearing: `Feature` is the union of these literal VALUES.
 */
export const sharedFeatures = {
  SAVE: "save",
  HOLD_ORDER: "hold_order",
  DISCOUNT: "discount",
  PRINT_BILL: "print_bill",
  QUICK_SETTLE: "quick_settle",
  CHECKOUT: "checkout",
  FULFILLMENT_CTA: "fulfillment_cta",
  PROCESSING_TIME: "processing_time",
  UNABLE_TO_ACCEPT: "unable_to_accept",
  CALL: "call",
  ACCEPT: "accept",
  REJECT: "reject",
  SEND_DIGITAL_BILL: "send_digital_bill",
  MARK_OOS: "mark_oos",
  MARK_READY: "mark_ready",
  REQUEST_APPROVAL: "request_approval",
  RETURN_OTP: "return_otp",
  EDIT_ITEMS: "edit_items",
  CANCEL_KOT: "cancel_kot",
  UNCANCEL_SALE: "uncancel_sale",
  CLOSE_SALE: "close_sale",
  CANCEL_SALE: "cancel_sale",
  VOID_SALE: "void_sale",
  UNVOID_SALE: "unvoid_sale",
  OUTLET_STATUS: "outlet_status",
  HELP_CTA: "help_cta",
  CANCEL_RIDER: "cancel_rider",
  FEEDBACK_CTA: "feedback_cta",
  SALE_RETURN: "sale_return",
  SALE_BY: "sale_by",
  BACK_ORDER: "back_order",
  OVERRIDE_ITEM_NAME: "override_item_name",
  EDIT_CHARGES: "edit_charges",
  EDIT_CUSTOMER: "edit_customer",
  BRANCH_CLOSE: "branch_close",
  CHANGE_BRANCH: "change_branch",
  ONLINE_ORDER_NOTIFICATION: "online_order_notification",
  OVERRIDE_DISCOUNT: "override_discount",
  TRANSFER_ITEMS: "transfer_items",
  ALLOWED: "ALLOWED",
  NC_SALE: "nc_sale",
  SPLIT_PAYMENT: "split_payment",
  PARTIAL_PAYMENT: "partial_payment",
  FULL_PAYMENT: "full_payment",
  TRANSFER_TABLE: "transfer_table",
  CUSTOM: "custom",
  PRINT_ITEM_LABEL_STICKER: "print_item_label_sticker",
  ASSIGN_RIDER: "assign_rider",
  REPRINT_KOT: "reprint_kot",
  GENERATE_BILL: "generate_bill",
  SALE_REOPEN: "sale_reopen",
  CUSTOMER_INFO: "customer_info",
  ACTIVITY_LOG: "activity_log",
  POS_PREFERENCES: "pos_preferences",
  DELETE_CTA: "delete_cta",
} as const;

/** The app-facing name. Same object as `sharedFeatures`, which the my-orders v2 code imports. */
export const FEATURES = sharedFeatures;

type FeatureKeys = keyof typeof FEATURES;

/** The union of every feature VALUE. */
export type Feature = (typeof FEATURES)[FeatureKeys];
